import React from 'react';
import { useQuill } from 'react-quilljs';
import 'quill/dist/quill.snow.css';

const AddFuente = (props) => {
	const { quillRef, editor } = useQuill({
		modules: {
			toolbar: [
				['bold', 'italic', 'underline', 'strike'],
				[{ align: [] }],
				[{ list: 'ordered' }, { list: 'bullet' }],
				[{ size: ['small', false, 'large', 'huge'] }],
				[{ color: [] }, { background: [] }],

				['clean'],
			],
		},
	});

	return (
		<div style={{ width: '100%', height: 'auto' }}>
			<div
				ref={quillRef}
				onInput={() => props.action(editor.root.innerHTML)}
				onBlur={() => props.action(editor.root.innerHTML)}
				id='fuente'
				tabIndex='11'
			/>
		</div>
	);
};

export default AddFuente;
